<template>
  <v-card>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('asset_wise.document_no') }}</div>
          <input v-model.trim="localValue.documentNumber" type="text" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('asset_wise.executive_name') }}</div>
          <input v-model.trim="localValue.executiveName" type="text" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('Start date') }}</div>
          <datepicker v-model="localValue.startDate" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('End date') }}</div>
          <datepicker v-model="localValue.endDate" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('Status') }}</div>
          <LandSaleStatusOptionListProvider>
            <template #default="{ options, loading }">
              <multiselect
                v-model="localValue.status"
                :options="options"
                track-by="value"
                label="text"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                :loading="loading"
              />
            </template>
          </LandSaleStatusOptionListProvider>
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('Province') }}</div>
          <ProvinceOptionListProvider>
            <template #default="{ options, loading }">
              <multiselect
                v-model="localValue.province"
                :options="options"
                track-by="value"
                label="text"
                :show-labels="false"
                :allow-empty="false"
                :loading="loading"
                @input="localValue.district = { value: '', text: $t('All') }"
              />
            </template>
          </ProvinceOptionListProvider>
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('asset_wise.district') }}</div>
          <DistrictOptionListProvider :province-id="localValue.province.value">
            <template #default="{ options, loading }">
              <multiselect
                v-model="localValue.district"
                :options="options"
                track-by="value"
                label="text"
                :show-labels="false"
                :allow-empty="false"
                :loading="loading"
                :disabled="localValue.province.value === ''"
              />
            </template>
          </DistrictOptionListProvider>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="clear()">
        {{ $t('Clear Search') }}
      </v-btn>
      <v-btn color="primary" @click="emit()">
        <v-icon>search</v-icon>
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import LandSaleStatusOptionListProvider from '../../providers/LandSaleStatusOptionListProvider.vue'
import ProvinceOptionListProvider from '../../providers/ProvinceOptionListProvider.vue'
import DistrictOptionListProvider from '../../providers/DistrictOptionListProvider.vue'

export default {
  components: {
    Datepicker,
    Multiselect,
    LandSaleStatusOptionListProvider,
    ProvinceOptionListProvider,
    DistrictOptionListProvider
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localValue: {
        documentNumber: '',
        executiveName: '',
        startDate: null,
        endDate: null,
        status: { value: '', text: this.$t('All') },
        province: { value: '', text: this.$t('All') },
        district: { value: '', text: this.$t('All') },
        ...this.value
      }
    }
  },
  watch: {
    value(value) {
      this.localValue = { ...this.localValue, ...value }
    }
  },
  methods: {
    emit() {
      this.$emit('input', this.localValue)
    },
    clear() {
      this.localValue = {
        documentNumber: '',
        executiveName: '',
        startDate: new Date(dayjs().startOf('week').format('YYYY-MM-DD')),
        endDate: new Date(dayjs().endOf('week').format('YYYY-MM-DD')),
        status: { value: '', text: this.$t('All') },
        province: { value: '', text: this.$t('All') },
        district: { value: '', text: this.$t('All') }
      }
      this.emit()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/ExecutiveRecord/AdvancedSearch.vue